import Layout from '@layout/Index'

export const fairStock = [
  {
    path: '/fair-stock',
    component: Layout,
    children: [
      {
        path: 'table/:fairid',
        component: () => import('./pages/FairStockTable.vue'),
        name: '转盘库存管理',
        meta: {
          title: '转盘库存管理',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/fair-stock/fairStock.route.js